<template>
  <vk-modal @close="$emit('close')">
    <vk-modal-body>
      <vk-modal-content class="p-0 pos-relative">
        <vk-modal-close class="MODAL-CLOSE-ICON"/>
        <div class="d-flex fd-column:d" selenium="Pro-Card">
          <pro-card-header-new
              :avatar="publicProfile.service_provider.logo"
              :size="avatarSize"
              :is-selected="isSelected"
              :is-preselected="isPreselected"
              :is-touched="isTouched"
              :is-modal="true"
              class="PRO-INFO-MODAL-HEADER"
              @toggleSelection="$emit('toggleSelection')"
          />
          <div class="d-flex d-none:d fd-column m-t-3" @click="$emit('toggleSelection')">
            <h4 class="h4 m-y-0 text-bold">{{ publicProfile.service_provider.business_name }}</h4>
            <div class="text-bold c-gray80">Serving {{ $route.params.zipcode }}</div>
          </div>
        </div>
        <div class="PRO-NAME">
          <h4 class="h4 m-y-0 text-bold">{{ publicProfile.service_provider.business_name }}</h4>
          <div class="text-bold c-gray80">Serving {{ $route.params.zipcode }}</div>
        </div>

        <!-- Credentials Goes Here -->
        <pro-credentials :public-profile-id="publicProfile.id"/>

        <!-- Services Goes Here -->
        <pro-services :services="publicProfile.services"/>
        <pro-reviews :public-profile="publicProfile"/>
      </vk-modal-content>
    </vk-modal-body>
  </vk-modal>
</template>

<script>
import ProCardHeaderNew from '../ProCardHeaderNew';
import ProReviews from './components/ProReviews';
import ProCredentials from './components/ProCredentials';
import ProServices from './components/ProServices';

export default {
  name: 'pro-info-modal',
  components: {
    ProCardHeaderNew,
    ProReviews,
    ProCredentials,
    ProServices,
  },
  props: {
    publicProfile: {
      type: Object,
      required: true,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    isPreselected: {
      type: Boolean,
      default: false,
    },
    isTouched: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    avatarSize () {
      return this.$device.isWide ? 200 : 70;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  .PRO-INFO-MODAL-HEADER {
    position: relative;

    &:before {
      @include absolute(0, auto, auto, 0);
      @include rect(50px, 100%);
      content: '';

      @include desktop {
        @include absolute(32px, auto, auto, 0);
        @include rect(100%, 20px);
      }

      &.SELECTED {
        background-color: $color-depot;
      }
    }
  }

  .MODAL-CLOSE-ICON {
    @include absolute(10px, 10px, auto, auto);
    z-index: 10;
  }

  .PRO-NAME {
    display: none;

    @include desktop {
      display: flex;
      flex-direction: column;
      margin-left: 300px;
      margin-top: 24px;
    }
  }
</style>
